export const getLocalStorageState = (name = '') => {
  if (!name) {
    throw new Error('getLocalStorageState must have "name" param');
  }
  return window && window.localStorage.getItem(`${name}`);
};

export const removeLocalStorageState = (name = '') => {
  if (!name) {
    throw new Error('removeLocalStorageState must have "name" param');
  }
  window && window.localStorage.removeItem(`${name}`);
};

export const setLocalStorageState = (name = '', value = '') => {
  if (!name || value === undefined) {
    throw new Error('setLocalStorageState must have "name" and "value param');
  }
  window && window.localStorage.setItem(`${name}`, value);
};
